export default __webpack_public_path__ + "static/media/accounting_point_8.57269cf8.png";